module.exports = __webpack_public_path__ + "img/map.06d74605.png";